// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toubaotip .van-dialog__footer[data-v-f3871b7a]{display:none!important}.lissk[data-v-f3871b7a]{width:64vw}", ""]);
// Exports
module.exports = exports;
